import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const DEFAULT_TZ = 'America/Chicago';

export const todayIn = (tz) => dayjs().tz(tz).format('YYYY-MM-DD');

export const addDays = (date, n) => dayjs(date).add(n, 'day').format('YYYY-MM-DD');

export const mondayOf = (date) => {
  const d = dayjs(date);
  return d.subtract((d.day() + 6) % 7, 'day').format('YYYY-MM-DD');
};

export const startOfDayISO = (date, tz) => dayjs.tz(date, tz).toISOString();

export const dateIn = (iso, tz) => dayjs(iso).tz(tz).format('YYYY-MM-DD');

export const timeIn = (iso, tz) => dayjs(iso).tz(tz).format('h:mm A');

export const longDateIn = (iso, tz) => dayjs(iso).tz(tz).format('ddd, MMM D · h:mm A');

export const clockLabel = (hhmm) => (hhmm ? dayjs(`2000-01-01T${hhmm}`).format('h:mm A') : '');
